import { defineTokens } from '@chakra-ui/react/styled-system';

const zIndex = defineTokens.zIndex({
  base: {
    value: 0,
  },
  dialog: {
    value: 1300,
  },
  dialogOverlay: {
    value: 1299,
  },
  fullDialog: {
    value: 1200,
  },
  fullDialogOverlay: {
    value: 1199,
  },
  header: {
    value: 1100,
  },
  hide: {
    value: -1,
  },
  popover: {
    value: 1400,
  },
  select: {
    value: 1500,
  },
  toast: {
    value: 1550,
  },
  tooltip: {
    value: 1600,
  },
});

export default zIndex;
